import { isType } from '@nubank/nuds-web/utils/isType/isType';

import { objectToQueryString, queryStringToParameters } from '../../urlUtils';

import isCMSImage from './isCMSImage';

const WIDTH_VALUES = {
  xl: '1366',
  lg: '1152',
  md: '768',
  sm: '425',
  xs: '360',
};

const DPR_VALUES_BY_DENSITY = {
  '1x': '1',
  '2x': '2',
  '3x': '3',
};

export const addCMSQueryParametersToPath = (path, breakpoint, dpr) => {
  if (isCMSImage(path)) {
    const [filteredPath, oldQueryParameters] = path.split('?');
    const queryParameters = objectToQueryString({
      w: WIDTH_VALUES[breakpoint],
      dpr: DPR_VALUES_BY_DENSITY[dpr],
      auto: 'compress',
      ...queryStringToParameters(oldQueryParameters),
    });
    return `${filteredPath}${queryParameters}`;
  }
  return path;
};

export const addCMSQueryParametersToSrcSet = (srcSet = {
  xl: '',
  lg: '',
  md: '',
  sm: '',
  xs: '',
}) => Object.keys(srcSet).reduce((result, breakpoint) => {
  const srcSetBreakpointPath = srcSet[breakpoint];

  if (isType('object', srcSetBreakpointPath)) {
    const paths = Object.entries(srcSetBreakpointPath)
      .reduce((pathsResults, [dpr, breakpointDrpPath]) => ({
        ...pathsResults,
        [dpr]: addCMSQueryParametersToPath(breakpointDrpPath, breakpoint, dpr),
      }), {});

    return {
      ...result,
      [breakpoint]: paths,
    };
  }

  const breakpointPath = addCMSQueryParametersToPath(srcSetBreakpointPath, breakpoint);

  return {
    ...result,
    [breakpoint]: breakpointPath,
  };
}, {});
